import { all, put, takeEvery } from 'redux-saga/effects';
import {
  getManageAssessorAction,
  getManageAssessorSuccessAction,
  getManageAssessorFailureAction,
  setSaveManageAssessorSuccessAction,
  setSaveManageAssessorFailureAction,
  getManageAsesorUpdateSuccessAction,
  getManageAssessorUpdateFailureAction
} from '../../features/ManageAssessor/ManageAssessorSlice';
import {
  GET_MANAGE_ASSESSOR,
  SET_MANAGE_ASSESSOR,
  GET_MANAGE_ASSESSOR_UPDATE
} from '../../actions/ManageAssessor/ManageAssessorActionType';
import URLs from '../../../constants/urls';
import { apiPython as api } from '../../../service/api';
import { getSessionStorage } from '../../../utils/helpers';

function formatAssessorLoadError(error) {
  const d = error?.response?.data;
  if (typeof d === 'string') return d;
  if (d?.detail) {
    return typeof d.detail === 'string' ? d.detail : JSON.stringify(d.detail);
  }
  if (d?.message) return d.message;
  if (error?.message) return error.message;
  return 'Could not load assessors';
}

export function* getmanagAssessorCyclesSaga() {
  try {
    const perm = encodeURIComponent(getSessionStorage('PERMISSION_LEVEL') || 'A');
    const response = yield api.get(`${URLs.GET_MANAGE_ASSESSOR}?permissionLevel=${perm}`);
    yield put(getManageAssessorSuccessAction(response.data));
  } catch (error) {
    yield put(getManageAssessorFailureAction(formatAssessorLoadError(error)));
  }
}

export function* setSaveManageAssessorSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_MANAGE_ASSESSOR, body);
    yield put(setSaveManageAssessorSuccessAction(response.data));
    yield put(getManageAssessorAction());
  } catch (error) {
    yield put(setSaveManageAssessorFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Could not save'));
  }
}

export function* getmanageAssessorUpdateSaga({ payload: userSamID }) {
  try {
    const userId = userSamID || getSessionStorage("USER_ID");
    const response = yield api.get(`${URLs.GET_MANAGE_ASSESSOR_UPDATE}?userSamID=${userId}`);
    const envelope = response?.data;
    const raw = envelope?.data ?? envelope?.Data ?? envelope;
    const userDetail = Array.isArray(raw) ? raw[0] : raw;
    yield put(getManageAsesorUpdateSuccessAction(userDetail));
  } catch (error) {
    const errorMessage = 'Entered Invalid Employee QID';
    yield put(getManageAssessorUpdateFailureAction(errorMessage));
  }
}

export function* watchmanageManageAssessors() {
  yield takeEvery(GET_MANAGE_ASSESSOR, getmanagAssessorCyclesSaga);
  yield takeEvery(SET_MANAGE_ASSESSOR, setSaveManageAssessorSaga);
  yield takeEvery(GET_MANAGE_ASSESSOR_UPDATE, getmanageAssessorUpdateSaga);
}

export default function* manageAssessorSaga() {
  yield all([watchmanageManageAssessors()]);
}





